import React from 'react';
import { Card, CardContent, CardActions, Skeleton, Box } from '@mui/material';

const GlossaryCardSkeleton = () => (
  <Card 
    variant="outlined" 
    sx={{ 
      width: '100%',
      height: '100%', 
      minHeight: 280,
      display: 'flex', 
      flexDirection: 'column' 
    }}
  >
    <CardContent sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      p: 3,
      flexGrow: 1
    }}>
      <Box 
        display="flex" 
        alignItems="flex-start" 
        justifyContent="space-between" 
        mb={2}
      >
        <Skeleton variant="text" width="60%" height={32} />
        <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 3, flexShrink: 0 }} />
      </Box>
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="90%" />
      </Box>
      
      {/* Spacer */}
      <Box sx={{ flexGrow: 1 }} />
      
      <Box sx={{ borderTop: '1px solid #e0e0e0', pt: 2, mb: 2, flexShrink: 0 }} />
      <Box sx={{ flexShrink: 0 }}>
        <Skeleton variant="text" width={100} height={20} />
      </Box>
    </CardContent>
    <Box sx={{ borderTop: '1px solid #e0e0e0', flexShrink: 0 }} />
    <CardActions sx={{ 
      p: 2, 
      gap: 1, 
      flexShrink: 0
    }}>
      <Skeleton variant="rectangular" width={80} height={30} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" width={60} height={30} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" width={70} height={30} sx={{ borderRadius: 1, ml: 'auto' }} />
    </CardActions>
  </Card>
);

const GlossaryListSkeleton = ({ count = 6 }) => (
  <Box
    sx={{
      display: 'grid',
      gap: 3,
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, minmax(0, 1fr))'
      }
    }}
  >
    {Array.from({ length: count }).map((_, index) => (
      <GlossaryCardSkeleton key={index} />
    ))}
  </Box>
);

export default GlossaryListSkeleton;
